import * as api from '../api/index'
import { FETCH_ORDERS_BY_USER, FETCH_ORDER, UPSERT_ORDER, UPDATE_ORDER, START_LOADING, END_LOADING } from './constants'

export const getOrdersByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data: { data } } = await api.fetchOrdersByUser(searchQuery || {})
    dispatch({ type: FETCH_ORDERS_BY_USER, payload: data || [] })
  } catch (error) {
    console.log(error?.response || error)
  } finally {
    dispatch({ type: END_LOADING })
  }
}

export const getOrder = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchOrder(id)
    dispatch({ type: FETCH_ORDER, payload: data })
  } catch (error) {
    console.log(error?.response || error)
  }
}

export const upsertOrderFromInvoice = (invoice) => async (dispatch) => {
  if (!invoice) return
  try {
    const { data } = await api.upsertOrderFromInvoice(invoice)
    dispatch({ type: UPSERT_ORDER, payload: data })
  } catch (error) {
    console.log(error?.response || error)
  }
}

export const updateOrder = (id, updates, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateOrder(id, updates)
    dispatch({ type: UPDATE_ORDER, payload: data })
    openSnackbar && openSnackbar('Order updated')
  } catch (error) {
    console.log(error?.response || error)
  }
}
